export default "__VITE_ASSET__CFDZ8jCE__"